import { render, staticRenderFns } from "./ButtonPlan.vue?vue&type=template&id=304cfe5e&"
import script from "./ButtonPlan.vue?vue&type=script&lang=js&"
export * from "./ButtonPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports